import { Table, Tag } from 'antd'
import moment from 'moment'
import React from 'react'
import { Invoice } from 'types'
import addCurrencySymbol from 'utils/addCurrencySymbol'

interface PropTypes {
	invoiceData: Invoice | null
	loading: boolean
}

const SingleInvoiceTable: React.FC<PropTypes> = ({ invoiceData, loading }) => {
	/**
	 * Invoce Columns for Table of Single Invoice
	 */

	const invoiceColumns = [
		{ title: 'Fields', dataIndex: 'title', key: 'title' },
		{ title: 'Details', dataIndex: 'dataIndex', key: 'dataIndex' },
	]

	/**
	 * Single Invoice data for Table
	 */

	const currency = invoiceData?.client.currency_selected ?? 'INR'

	const invoiceTableData = [
		{
			title: `Amount (${currency})`,
			dataIndex: addCurrencySymbol(
				(invoiceData?.amount ?? 0) + (invoiceData?.tdsAmount ?? 0),
				invoiceData?.currency ?? currency
			),
		},
		{
			title: `Recieveable (${currency})`,
			dataIndex: addCurrencySymbol(
				invoiceData?.amount ?? 0,
				invoiceData?.currency ?? currency
			),
		},
		{
			title: `TDS Applicable (${currency})`,
			dataIndex: invoiceData?.tdsEnabled
				? addCurrencySymbol(
						invoiceData?.tdsAmount ?? 0,
						invoiceData?.currency ?? currency
				  )
				: '-',
		},
		{
			title: 'Date',
			dataIndex: moment(invoiceData?.createdAt).format('DD/MM/YYYY'),
		},
		{
			title: 'Client Name',
			dataIndex: invoiceData?.client ? invoiceData?.client.organizationName : '--',
		},
		{
			title: 'Client Mobile Number',
			dataIndex: invoiceData?.client
				? `+${invoiceData?.client.mobileNumber.code} ${invoiceData?.client.mobileNumber.mobile}`
				: '--',
		},
		{
			title: 'Client Email',
			dataIndex: invoiceData?.client ? invoiceData?.client.email : '--',
		},
		{
			title: 'Paid',
			dataIndex: invoiceData?.isPaid ? (
				<Tag color='green'>Yes</Tag>
			) : (
				<Tag color='red'>No</Tag>
			),
		},
		{
			title: `Paid Amount (${currency})`,
			dataIndex: addCurrencySymbol(
				invoiceData?.paidAmount ?? 0,
				invoiceData?.currency ?? currency
			),
		},
		{
			title: 'Payment URL',
			dataIndex: invoiceData?.payUrl ? (
				<a href={invoiceData?.payUrl} target='_blank' rel='noreferrer'>
					{invoiceData.payUrl}
				</a>
			) : (
				'--'
			),
		},
		{
			title: 'Selected Plan',
			dataIndex: invoiceData?.selectedPlan.billingCycle,
		},
		{
			title: 'Plan Price',
			dataIndex:
				invoiceData?.selectedPlan.billingCycle === 'MONTHLY'
					? addCurrencySymbol(
							invoiceData?.selectedPlan.perMonth ?? 0,
							invoiceData?.currency ?? currency
					  )
					: addCurrencySymbol(
							invoiceData?.selectedPlan.perYear ?? 0,
							invoiceData?.currency ?? currency
					  ),
		},
		{
			title: 'Start Date',
			dataIndex: invoiceData?.startDate
				? moment(invoiceData?.startDate).format('DD/MM/YYYY')
				: '--',
		},
		{
			title: 'Due Date',
			dataIndex: invoiceData?.dueDate
				? moment(invoiceData?.dueDate).format('DD/MM/YYYY')
				: '--',
		},
		{
			title: 'End Date',
			dataIndex: invoiceData?.endDate
				? moment(invoiceData?.endDate).format('DD/MM/YYYY')
				: '--',
		},
		{
			title: 'PDF URL',
			dataIndex: invoiceData?.url ? (
				<a href={invoiceData?.url} target='_blank' rel='noreferrer'>
					PDF Link
				</a>
			) : (
				'--'
			),
		},
		{
			title: 'Deleted',
			dataIndex: invoiceData?.isDeleted ? (
				<Tag color='red'>Yes</Tag>
			) : (
				<Tag color='green'>No</Tag>
			),
		},
	]

	return (
		<Table
			columns={invoiceColumns}
			dataSource={invoiceTableData}
			loading={loading}
			pagination={false}
		/>
	)
}

export default SingleInvoiceTable
